import { render, staticRenderFns } from "./ConsultaGeneral.vue?vue&type=template&id=f0ba1ec8&"
import script from "./ConsultaGeneral.vue?vue&type=script&lang=js&"
export * from "./ConsultaGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports